/*jshint esversion: 6 */

$(function () {
});
